import { BASE_REST_API_URL } from 'common/constants';
import type { SerializedUser } from '@enmon/commons/lib/tools';
import type { BaseAPIParams } from 'lib/utils/BaseAPIParams';
import { type Populate, buildQuery } from '@enmon/commons/lib/tools/utils/buildQuery';
import { BaseApiClient } from './baseApiClient';

export type Filter = BaseAPIParams<SerializedUser> & {
  id?: SerializedUser['id'];
};

/**
 * API client for users from user-permissions Strapi plugin.
 *
 * @deprecated Use class instead because there is only one implementation of this interface which makes searching for references
 * more difficult, name shouldn't be prefixed too: https://blog.nette.org/en/prefixes-and-suffixes-do-not-belong-in-interface-names.
 */
export interface IUsersApiClient {
  /**
   * Find user from user-permissions plugin by ID.
   */
  findById(id: SerializedUser['id'], filter: Filter): Promise<SerializedUser>;
}

export class UsersApiClient extends BaseApiClient implements IUsersApiClient {
  constructor(jwt: string) {
    super('users', BASE_REST_API_URL, jwt);
  }

  public async findById(id: SerializedUser['id'], filter: Filter = {}): Promise<SerializedUser> {
    const { populate, page, pageSize, sort } = filter;

    const populateAttribute = populate as Populate<SerializedUser>;

    const response = await this.axios.get<SerializedUser>(id.toString(), {
      params: buildQuery<SerializedUser>({
        ...(populate && { populate: populateAttribute }),
        sort,
        filters: {},
        pagination: {
          page,
          pageSize,
        },
      }),
    });

    return response.data;
  }
}
